import { baseApi } from './baseApi'

export const authApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        signIn: builder.mutation({
            query: (credentials) => ({
                url: '/auth/signin',
                method: 'POST',
                body: credentials
            })
        }),
        signOut: builder.mutation({
            query: (refreshToken) => ({
                url: '/auth/logout',
                method: 'POST',
                body: { refreshToken }
            })
        }),
        getSessions: builder.query({
            query: () => '/auth/sessions',
            providesTags: ['Sessions']
        }),
        revokeSession: builder.mutation({
            query: (tid) => ({
                url: `/auth/sessions/${tid}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Sessions']
        }),
        getUserSessions: builder.query({
            query: (userId) => `/auth/users/${userId}/sessions`,
            providesTags: (result, error, userId) => [{ type: 'Sessions', id: userId }]
        }),
        revokeUserSession: builder.mutation({
            query: ({ userId, tid }) => ({
                url: `/auth/users/${userId}/sessions/${tid}`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, { userId }) => [{ type: 'Sessions', id: userId }]
        }),
        revokeAllUserSessions: builder.mutation({
            query: (userId) => ({
                url: `/auth/users/${userId}/sessions`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, userId) => [{ type: 'Sessions', id: userId }]
        }),
        checkAuth: builder.query({
            query: () => '/auth/check'
        })
    })
})

export const {
    useSignInMutation,
    useSignOutMutation,
    useGetSessionsQuery,
    useRevokeSessionMutation,
    useGetUserSessionsQuery,
    useRevokeUserSessionMutation,
    useRevokeAllUserSessionsMutation,
    useCheckAuthQuery
} = authApi
